const validateUrl = ({
  url,
  allowTags = false,
  allowOnlyHttpProtocols = false,
  deeplinkUrlScheme = null,
}: {
  url: string;
  allowTags?: boolean;
  allowOnlyHttpProtocols?: boolean;
  deeplinkUrlScheme?: string | null;
}): boolean => {
  let finalUrl = url;
  if (allowTags) {
    finalUrl = url.replace(/\{[^{}]+\}/g, "");
  }
  if (/\s/.test(finalUrl)) return false;

  if (deeplinkUrlScheme && finalUrl.startsWith(`${deeplinkUrlScheme}://`)) {
    return true;
  }

  if (allowOnlyHttpProtocols && !/^https?:\/\//.test(finalUrl)) {
    return false;
  }
  try {
    new URL(finalUrl);
  } catch (e) {
    return false;
  }
  return true;
};

export { validateUrl };
